import { render, staticRenderFns } from "./ComboBox.vue?vue&type=template&id=452e85a0&scoped=true"
import script from "./ComboBox.vue?vue&type=script&lang=js"
export * from "./ComboBox.vue?vue&type=script&lang=js"
import style0 from "./ComboBox.vue?vue&type=style&index=0&id=452e85a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e85a0",
  null
  
)

/* custom blocks */
import block0 from "./ComboBox.vue?vue&type=custom&index=0&blockType=i18n&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports